export default function tempConverter(tempInCelsius, unit = "celsius"){
    if (unit === "celsius"){
        return Math.round(tempInCelsius);
    }else if (unit === "fahrenheit"){
        return Math.round((tempInCelsius * 9/5) + 32);
    }
}